import React, { useEffect, useState } from "react";
import {
  GetEmpLeaves,
  insertUpdatedLeave,
  ProcessEmpLeave,
  RemoveSpecialLeave,
} from "../../services/dataService";
import toast from "react-hot-toast";
import { getSecureItem } from "../../services/SecureStorage";

function EmployeeLeave({ EmpId }) {
  const UID = getSecureItem("userId");
  const [leavesData, setLeavesData] = useState({ totalLeaves: [] });
  const [editingId, setEditingId] = useState(null);
  const [editedValue, setEditedValue] = useState("");
  const [editedTotalLeave, setEditedTotalLeave] = useState("");

  const fetchTotalLeave = async () => {
    const data = { UserId: UID, EmpId };
    try {
      const response = await GetEmpLeaves(data);
      if (response.data.data && response.data.data.length > 0) {
        setLeavesData({
          totalLeaves: response.data.data[0] || [],
        });
      }
    } catch (error) {
      console.error("Error fetching leaves:", error);
      toast.error("Failed to fetch leave data");
    }
  };

  useEffect(() => {
    fetchTotalLeave();
  }, [EmpId, UID]);

  useEffect(() => {
    const processleave = async () => {
      try {
        const data = { UserId: UID, EmpId };
        const response = await ProcessEmpLeave(data);

        if (response.status === 201) {
          fetchTotalLeave();
        }

        console.log(response, "Response Log");
      } catch (error) {
        console.error("Error processing leave:", error);
      }
    };
    processleave();
  }, [UID, EmpId]);

  const handleEdit = (id, currentValue, currentTakenDays) => {
    setEditingId(id);
    setEditedValue(currentValue);
    setEditedTotalLeave(currentTakenDays);
  };

  const handleSave = async (id, leave) => {
    // console.log(leave,'subin');
    const initialCount = leave.IniTialCount;
    const noOfLeaves = parseFloat(editedValue);
    const takenLeaves = parseFloat(editedTotalLeave);
    if (initialCount < noOfLeaves) {
      toast.error(`NoOfDays not grater than ${initialCount}`);
      return;
    }
    // ✅ Validation: taken > total
    if (takenLeaves > noOfLeaves) {
      toast.error("Taken leaves cannot be greater than total number of leaves");
      return;
    }

    // ✅ Validation: negative values
    if (noOfLeaves < 0 || takenLeaves < 0) {
      toast.error("Leave values cannot be negative");
      return;
    }

    // ✅ Validation: must be numbers
    if (isNaN(noOfLeaves) || isNaN(takenLeaves)) {
      toast.error("Please enter valid numbers");
      return;
    }

    try {
      const leaveToUpdate = leavesData.totalLeaves.find(
        (leave) => leave.Id === id
      );

      if (!leaveToUpdate) {
        toast.error("Leave not found for the given ID");
        return;
      }

      const updatedLeave = {
        ...leaveToUpdate,
        NoOfLeaves: noOfLeaves,
        TakenLeaves: takenLeaves,
        UserId: UID,
        EmpId: EmpId,
      };

      const resp = await insertUpdatedLeave(updatedLeave);

      // ✅ Extract actual data from response
      const message = resp?.data?.data?.message;
      const statusCode = resp?.data?.data?.StatusCode;

      if (statusCode === 200) {
        toast.success(message || "Leave updated successfully");

        // ✅ Update local state
        setLeavesData((prev) => ({
          ...prev,
          totalLeaves: prev.totalLeaves.map((leave) =>
            leave.Id === id ? updatedLeave : leave
          ),
        }));

        setEditingId(null);
        fetchTotalLeave();
      } else {
        toast.error(message || "Failed to update leave");
      }
    } catch (error) {
      console.error("Error updating leave:", error);
      toast.error("Something went wrong while updating leave");
    }
  };

  const handleCancel = () => {
    setEditingId(null);
  };

  const handleToggleEnable = async (leave) => {
    try {
      const newStatus = leave.Status === 0 ? 3 : 0; // Toggle between 0 (Enable) and 3 (Disable)
      const data = {
        UserId: UID,
        EmpId: EmpId,
        LeaveId: leave.Id,
        TypeId: leave.TypeId,
        Year: leave.Year,
        Status: newStatus,
      };

      const response = await RemoveSpecialLeave(data);

      if (response.success || response.status === 200) {
        setLeavesData((prev) => ({
          ...prev,
          totalLeaves: prev.totalLeaves.map((l) =>
            l.Id === leave.Id ? { ...l, Status: newStatus } : l
          ),
        }));
        toast.success(
          `Special leave ${
            newStatus === 0 ? "enabled" : "disabled"
          } successfully`
        );
        fetchTotalLeave();
      } else {
        toast.error(
          `Failed to ${newStatus === 0 ? "enable" : "disable"} special leave`
        );
      }
    } catch (error) {
      console.error(
        `Error ${leave.Status === 0 ? "disabling" : "enabling"} special leave:`,
        error
      );
      toast.error(
        `Failed to ${leave.Status === 0 ? "disable" : "enable"} special leave`
      );
    }
  };

  const isSpecialLeave = (leaveName) => {
    return leaveName === "Special Leave";
  };

  return (
    <div className="w-full max-w-4xl mx-auto p-4 bg-white shadow-lg rounded-lg">
      <h3 className="text-xl font-semibold mb-6 text-gray-800">
        Leave Details
      </h3>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-gray-300 p-3 text-left font-medium">
                Leave Type
              </th>
              <th className="border border-gray-300 p-3 text-left font-medium">
                Year
              </th>
              <th className="border border-gray-300 p-3 text-left font-medium">
                No Of Leaves
              </th>
              <th className="border border-gray-300 p-3 text-left font-medium">
                Taken Leaves
              </th>
              <th className="border border-gray-300 p-3 text-left font-medium">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {leavesData.totalLeaves.map((leave) => (
              <tr
                key={leave.Id}
                className={`${
                  leave.Status === 3 ? "bg-red-500 text-white" : ""
                }`}
              >
                <td className="border border-gray-300 p-3">
                  <span
                    className={`${
                      isSpecialLeave(leave.LeaveName)
                        ? "font-medium text-blue-600"
                        : ""
                    }`}
                  >
                    {leave.LeaveName}
                  </span>
                </td>
                <td className="border border-gray-300 p-3">{leave.Year}</td>
                <td className="border border-gray-300 p-3">
                  {editingId === leave.Id ? (
                    <input
                      type="number"
                      className="w-[100px] border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={editedValue}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || Number(value) >= 0) {
                          setEditedValue(value);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e") {
                          e.preventDefault();
                        }
                      }}
                      min="0"
                    />
                  ) : (
                    leave.NoOfLeaves
                  )}
                </td>
                <td className="border border-gray-300 p-3">
                  {editingId === leave.Id ? (
                    <input
                      type="number"
                      className="w-[100px] border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={editedTotalLeave}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || Number(value) >= 0) {
                          setEditedTotalLeave(value);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e") {
                          e.preventDefault();
                        }
                      }}
                      min="0"
                    />
                  ) : (
                    leave.TakenLeaves
                  )}
                </td>
                <td className="border border-gray-300 p-3">
                  <div className="flex space-x-2">
                    {editingId === leave.Id ? (
                      <>
                        <button
                          className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-sm transition-colors"
                          onClick={() => handleSave(leave.Id, leave)}
                        >
                          Save
                        </button>
                        <button
                          className="bg-gray-500 hover:bg-gray-600 text-white px-3 py-1 rounded text-sm transition-colors"
                          onClick={handleCancel}
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <>
                        {leave.Status === 0 && (
                          <button
                            className="bg-blue hover:bg-blue-600 text-white px-3 py-1 rounded text-sm transition-colors"
                            onClick={() =>
                              handleEdit(
                                leave.Id,
                                leave.NoOfLeaves,
                                leave.TakenLeaves
                              )
                            }
                          >
                            Edit
                          </button>
                        )}
                        {isSpecialLeave(leave.LeaveName) && (
                          <button
                            className={`${
                              leave.Status === 0
                                ? "bg-yellow hover:bg-yellow"
                                : "bg-green-600 hover:bg-green-600"
                            } text-white px-3 py-1 rounded text-sm transition-colors`}
                            onClick={() => handleToggleEnable(leave)}
                          >
                            {leave.Status === 0
                              ? "Click to Disable"
                              : "Click to Enable"}
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {leavesData.totalLeaves.length === 0 && (
        <div className="text-center py-8 text-gray-500">
          No leave data available
        </div>
      )}
    </div>
  );
}

export default EmployeeLeave;
